module.exports = __webpack_public_path__ + "img/system-pvp-img.2d3b78ef.jpg";